import workerService from '@/services/worker.service';

const state = {
    id: Number,
    personalInfo: Object,
    contacts: Array,
    professions: Array,
    workerTeams: Array,
    generalStatus: Object,
    notes: Array,
    languages: Array,
    educations: Array,
    workerCompany: Object,
    generalStatusHistory: Array,
    isLoading: Boolean,
    isProfilePictureLoading: Boolean,
    workerProfilePicture: null
};

const getters = {
    personalInfo: (state) => state.personalInfo,
    contacts: (state) => state.contacts,
    isWorkerLoading: (state) => state.isLoading,
    professions: (state) => state.professions,
    workerTeams: (state) => state.workerTeams,
    workerGeneralStatus: (state) => state.generalStatus,
    workerNotes: (state) => state.notes,
    workerEducations: (state) => state.educations,
    workerLanguages: (state) => state.languages,
    workerCompany: (state) => state.workerCompany,
    generalStatusHistory: (state) => state.generalStatusHistory,
    isProfilePictureLoading: (state) => state.isProfilePictureLoading,
    workerProfilePicture: (state) => state.workerProfilePicture
};

const actions = {
    fetchWorker({commit}, id) {
        commit('setIsWorkerLoading', true);
        workerService.fetchWorkerById(id)
            .then(({data}) => {
                commit('setId', data.id);
                commit('setPersonalInfo', data.personalInfo);
                commit('setContacts', data.contacts);
                commit('setProfessions', data.professions);
                commit('setWorkerTeams', data.teams);
                commit('setWorkerGeneralStatus', data.generalStatus);
                commit('setWorkerNotes', data.notes);
                commit('setWorkerLanguages', data.languages);
                commit('setWorkerEducations', data.educations);
                commit('setWorkerCompany', data.company);
                commit('setGeneralStatusHistory', data.generalStatusHistory);
                commit('setIsWorkerLoading', false);
            })
            .catch(() => commit('setIsWorkerLoading', false));
    },
    fetchWorkerProfilePicture({commit}, id) {
        commit('setIsProfilePictureLoading', true);
        workerService.fetchWorkerProfilePicture(id)
            .then(({data}) => {
                commit('setProfilePicture', data);
                commit('setIsProfilePictureLoading', false);
            })
            .catch(() => commit('setIsProfilePictureLoading', false));
    }
};

const mutations = {
    setId: (state, id) => (state.id = id),
    setPersonalInfo: (state, personalInfo) => (state.personalInfo = personalInfo),
    setContacts: (state, contacts) => (state.contacts = contacts),
    setIsWorkerLoading: (state, isLoading) => (state.isLoading = isLoading),
    setProfessions: (state, professions) => (state.professions = professions),
    setWorkerTeams: (state, teams) => (state.workerTeams = teams),
    setWorkerGeneralStatus: (state, status) => (state.generalStatus = status),
    setWorkerNotes: (state, notes) => (state.notes = notes),
    setWorkerLanguages: (state, languages) => (state.languages = languages),
    setWorkerEducations: (state, educations) => (state.educations = educations),
    setProfilePicture: (state, picture) => (state.workerProfilePicture = picture),
    setWorkerCompany: (state, company) => (state.workerCompany = company),
    setGeneralStatusHistory: (state, generalStatusHistory) => (state.generalStatusHistory = generalStatusHistory),
    setIsProfilePictureLoading: (state, isLoading) => (state.isProfilePictureLoading = isLoading)
};

export default {
    state,
    getters,
    actions,
    mutations
};
